import { SvgIcon } from '@mui/material';

const ChevronLeft = () => (
  <SvgIcon
    viewBox="0 0 12 18"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 8, height: 8, fill: 'none' }}
    data-testid="blackChevronIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9142 0.585786C11.6953 1.36683 11.6953 2.63317 10.9142 3.41421L5.32843 9L10.9142 14.5858C11.6953 15.3668 11.6953 16.6332 10.9142 17.4142C10.1332 18.1953 8.86683 18.1953 8.08579 17.4142L1.08579 10.4142C0.304738 9.63317 0.304738 8.36683 1.08579 7.58579L8.08579 0.585786C8.86683 -0.195262 10.1332 -0.195262 10.9142 0.585786Z"
      fill="#0B1421"
    />
  </SvgIcon>
);

export default ChevronLeft;
